import {DatePeriodEnum} from '../../../../../../util/date';

const AnalyticsKeywordsAndTopicsFormMap: Record<DatePeriodEnum, string> = {
    [DatePeriodEnum.Custom]: 'Custom',
    [DatePeriodEnum.Day]: 'Day',
    [DatePeriodEnum.Month]: '30 Days',
    [DatePeriodEnum.PreviousFullMonth]: 'Month',
    [DatePeriodEnum.Quarter]: 'Quater',
    [DatePeriodEnum.Week]: 'Week',
};

export function getDateAndPeriodForAnalysis(
    range: [Date | null, Date | null],
    periodOption: DatePeriodEnum
): [string, string] {
    return [`${range[0]} - ${range[1]}`, AnalyticsKeywordsAndTopicsFormMap[periodOption]];
}
